@if (wrapper.isReady) {
  <div [class]="getFormGroupClass()">
    <acc-form-label [name]="name" [wrapper]="wrapper" [size]="config.size"/>
    <div class="input-group">
      <input type="text" class="form-control" [class]="getClass()"
             #input #instance="ngbTypeahead"
             [id]="name"
             [name]="name"
             [(ngModel)]="model"
             [ngbTypeahead]="search"
             [inputFormatter]="formatter"
             [resultTemplate]="formatterTpl"
             (focus)="focusTypeahead.next($any($event).target.value)"
             (click)="clickTypeahead.next($any($event).target.value)"
             (change)="onInputChange($event)"
             (keydown.enter)="onInputChange($event)"
             (keydown.tab)="onInputChange($event)"
             (ngModelChange)="changeTypeahead.next($any($event).target?.value)"
             [placeholder]="getPlaceholder()|translate"
             [class.is-invalid]="isInvalid()"
             [attr.aria-describedby]="name + '-clean-action'"
             [disabled]="isViewOnly()"
             [readonly]="!changeable"
             [ngStyle]="getStyle()"
             [ngbTooltip]="getModelValue()" [openDelay]="400"/>
      @if (showCleanAction && !isViewOnly()) {
        <span class="input-group-text acc-clean-action" [class]="getClass()"
              [ngbPopover]="'form.select.clear'|translate"
              [id]="name + '-clean-action'"
              (click)="cleanValue()" (keydown.enter)="cleanValue()" tabindex="0">
          <acc-icon name="typeahead-clean"/>
        </span>
      }
    </div>
    <acc-form-field-error [name]="name" [wrapper]="wrapper"/>
  </div>
}

<ng-template #formatterTpl let-data="result"> <!-- let-term="term" -->
  <div [id]="getDataIdForResult(data)"
       (click)="selectTypeahead.next(data)" (keydown.enter)="selectTypeahead.next(data)" tabindex="0">
    @if (data.icon) {
      <acc-icon [name]="data.icon" class="me-2"></acc-icon>
    }
    @if (data.hasTranslatedValue()) {
      <span>{{ data.translatedValue }}</span>
    } @else if (data.hasTranslation()) {
      <span>{{ data.translation|translate }}</span>
    } @else if (!data.hasTranslation() && !data.isHtml) {
      <span>{{ data.name }}</span>
    } @else if (!data.hasTranslation() && data.isHtml) {
      <span [innerHTML]="formatHtml(data.name)|accSafeHtml"></span>
    }
  </div>
</ng-template>
